import React, { Component } from "react"
import { connect } from "react-redux"
import * as actionCreators from "../redux/action_creators"
import { appStrings } from "../common/strings/app_strings"
import { appConsts } from "../common/constants/app_consts"
import {
    renderOutlineClass,
    parseVerificationCode,
    getLocalStorageItem,
} from "../util/onboarding_utils"

const {
    welcome,
    send,
    dash,
    didntReceive,
    resend,
    codeInvalid,
    resendInvalid,
} = appStrings.onboarding.signUpConfirmation
const { wrongEmail } = appStrings.onboarding
const { verificationCodeBoxes } = appConsts
const codeLength = verificationCodeBoxes.length

class SignUpConfirmation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            inputValue: "",
            invalidCodeSent: false,
            canSubmit: true,
        }

        this.textInput = null

        // // callback refs, storing a reference to a DOM node in an instance prop
        this.setTextInputRef = element => (this.textInput = element)

        this.focusTextInput = () => {
            // focus the text input using raw DOM API
            if (this.textInput) this.textInput.focus()
        }
    }

    componentDidMount() {
        // autofocus the input on mount
        this.focusTextInput()
    }

    onChange = e => {
        const { canSubmit } = this.state
        const value = e.target.value
        // if the user copies and pastes code from email
        const formatValue = parseVerificationCode(value)
        const exceedsCodeLength = formatValue.length > codeLength
        const truncateValue = exceedsCodeLength
            ? formatValue.slice(0, codeLength)
            : formatValue

        this.setState({ inputValue: truncateValue }, () => {
            if (truncateValue.length === codeLength && canSubmit) {
                this.props.verifyEmail(truncateValue)
                // debounce submitting
                this.setState({ canSubmit: false }, () => {
                    setTimeout(() => this.setState({ canSubmit: true }), 1000)
                })
                // set error message if still on confirmation page
                setTimeout(() => this.setState({ invalidCodeSent: true }), 1200)
            }
        })
    }

    renderTextBoxes = () => {
        const { inputValue } = this.state
        const splitValueChars = inputValue.split("")

        return verificationCodeBoxes.map(index => {
            return (
                <div className="display-box-dash" key={index}>
                    {index === codeLength / 2 && (
                        <div className="display-dash">{dash}</div>
                    )}
                    <div
                        key={index}
                        className={`display-box ${renderOutlineClass(
                            verificationCodeBoxes.length,
                            splitValueChars.length,
                            index,
                        )}`}
                    >
                        {splitValueChars[index]}
                    </div>
                </div>
            )
        })
    }

    onClickResendVerification = () => {
        const { resendVerificationCode } = this.props
        resendVerificationCode()
    }

    render() {
        const { invalidCodeSent } = this.state
        const email = getLocalStorageItem("email")
        return (
            <div className="sign-up-confirm-container">
                <h2 className="sign-up-confirm-header">{welcome}</h2>
                <p className="sign-up-send-email">
                    {send} <span>{email}</span>
                </p>
                <span className="link-text sign-up-send-link" onClick={this.props.signOut}>
                    {wrongEmail}
                </span>
               
                <div
                    className="display-box-wrapper"
                    onClick={this.focusTextInput}
                >
                    <input
                        className="input"
                        ref={this.setTextInputRef}
                        onChange={this.onChange}
                        value={this.state.inputValue}
                        spellCheck="false"
                    />
                    {this.renderTextBoxes()}
                </div>
                <p className="sign-up-resend-code">
                    {invalidCodeSent ? codeInvalid : didntReceive}
                    <span
                        className="link-text"
                        onClick={this.onClickResendVerification}
                    >
                        {invalidCodeSent ? resendInvalid : resend}
                    </span>
                </p>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return state
}

export default connect(
    mapStateToProps,
    actionCreators,
)(SignUpConfirmation)



// WEBPACK FOOTER //
// ./src/pages/sign_up_confirmation.jsx